import { ErrorViewTmpl } from '@libs/templates/template-pages/templates';
import { Link } from 'react-router';

function Component() {
  return (
    <ErrorViewTmpl title="404 ページが見つかりません">
      <br />
      お探しのページは削除されたかURLが変更された可能性があります。
      <br />
      <br />
      トップページへ戻り、メインメニューから再度操作をお試しください。
      <br />
      <br />
      <Link to="/">[トップページへ戻る]</Link>
      <br />
      <br />
      ※何度もこの画面が表示される場合は、システム管理者へお問い合わせください
    </ErrorViewTmpl>
  );
}

Component.displayName = 'NotFound';

export { Component };
